import { Box, Button, Divider, Link, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { themeColors } from '../../JuvareTheme';
import { useCommonWebTranslation } from '../../hooks';
export const LoginForm = ({ disabled, loginEmail, onLoginContinue, onLoginOther, onLogin, forgotPasswordHref, onForgotPassword, onRegister, footerElement, footerHtml, }) => {
    const { t } = useCommonWebTranslation();
    const navigate = useNavigate();
    return (React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 3, alignItems: 'stretch' } },
        loginEmail && onLoginContinue && onLoginOther ? (React.createElement(React.Fragment, null,
            React.createElement(Button, { variant: 'contained', sx: { display: 'block', overflow: 'hidden', textOverflow: 'ellipsis' }, onClick: () => onLoginContinue(navigate, loginEmail), disabled: disabled }, t('landingApp.continueAs', { loginEmail })),
            React.createElement(Button, { variant: 'outlined', onClick: () => onLoginOther(navigate), disabled: disabled }, t('landingApp.logInAsDifferentUser')))) : (React.createElement(Button, { variant: 'contained', onClick: () => onLogin(navigate), disabled: disabled }, t('landingApp.logIn'))),
        (onForgotPassword || forgotPasswordHref) && (React.createElement(Typography, { variant: 'subtitle2' },
            React.createElement(Link, { sx: { cursor: 'pointer' }, href: forgotPasswordHref, onClick: onForgotPassword
                    ? (event) => {
                        onForgotPassword(navigate);
                        event.preventDefault();
                    }
                    : undefined }, t('landingApp.forgotPassword')))),
        onRegister && (React.createElement(React.Fragment, null,
            React.createElement(Divider, null,
                React.createElement(Typography, { variant: 'caption', sx: { color: themeColors.border.boldest } }, t('common.or'))),
            React.createElement(Button, { variant: 'outlined', onClick: () => onRegister(navigate), disabled: disabled }, t('landingApp.register')))),
        React.createElement(Typography, { variant: 'caption', sx: {
                color: themeColors.text.subtle,
                '& a': {
                    color: themeColors.text.link,
                    textDecoration: 'none',
                },
                '& a:hover': {
                    textDecoration: 'underline',
                },
            } },
            footerElement && footerElement,
            !footerElement && footerHtml && React.createElement("div", { dangerouslySetInnerHTML: { __html: footerHtml } }),
            !footerElement && !footerHtml && React.createElement("div", { dangerouslySetInnerHTML: { __html: t('landingApp.defaultFooterHtml') } }))));
};
